'use client'

import { useState, useEffect } from 'react';
import { sanitizeHtml } from '../../utils/sanitize';
import { CookiesButton, CookiesContainer, CookiesDescription } from './styles';

interface CookiesModalProps {
  description: string;
  buttonText: string;
  buttonColor: string;
}

export const CookiesModal = ({ description, buttonText, buttonColor }: CookiesModalProps) => {
  const [mounted, setMounted] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const hasAccepted = localStorage.getItem('acceptCookies');
    if (hasAccepted) {
      setAccepted(true);
    }
  }, []);

  const closeModal = () => {
    localStorage.setItem('acceptCookies', 'true');
    setAccepted(true);
  };

  // Não renderiza nada até montar no cliente (evita hydration mismatch)
  if (!mounted || accepted) {
    return null;
  }

  return (
    <CookiesContainer>
      <CookiesDescription
        dangerouslySetInnerHTML={{__html: sanitizeHtml(description) }}
      ></CookiesDescription>

      <CookiesButton
        onClick={closeModal}
        bgColor={buttonColor}
      >{buttonText}</CookiesButton>
    </CookiesContainer>
  );
};
